import api from '../api';
import {
  PIN_RESET_STATE_RESET,
  PIN_FORGOT_STATE_RESET,
  PIN_OPEN_FORGOT_PIN_MODAL,
  PIN_CLOSE_FORGOT_PIN_MODAL
} from '../actions/pin';

const PIN_FORGOT_SUCCESS = api.events.pinForgot.actionSuccess;
const PIN_FORGOT_FAILURE = api.events.pinForgot.actionFail;
const PIN_RESET_SUCCESS = api.events.pinReset.actionSuccess;
const PIN_RESET_FAILURE = api.events.pinReset.actionFail;

const defaultState = {
  isForgotPinSuccessMessageVisible: false,
  isForgotPinFailureMessageVisible: false,
  showResetSuccessMessage: false,
  showResetFailureMessage: false,
  isForgotPinModalOpen: false
};

export default function ui(state = defaultState, action) {
  switch (action.type) {
    case PIN_FORGOT_SUCCESS:
      return {
        ...state,
        isForgotPinSuccessMessageVisible: true,
        isForgotPinFailureMessageVisible: false
      };
    case PIN_FORGOT_FAILURE:
      return {
        ...state,
        isForgotPinSuccessMessageVisible: false,
        isForgotPinFailureMessageVisible: true
      };
    case PIN_FORGOT_STATE_RESET:
      return {
        ...state,
        isForgotPinSuccessMessageVisible: false,
        isForgotPinFailureMessageVisible: false
      };
    case PIN_RESET_SUCCESS:
      return {
        ...state,
        showResetSuccessMessage: true,
        showResetFailureMessage: false,
        isForgotPinSuccessMessageVisible: false,
        isForgotPinFailureMessageVisible: false,
      };
    case PIN_RESET_FAILURE:
      return {
        ...state,
        showResetSuccessMessage: false,
        showResetFailureMessage: true,
        isForgotPinSuccessMessageVisible: false,
        isForgotPinFailureMessageVisible: false,
      };
    case PIN_RESET_STATE_RESET:
      return {
        ...state,
        showResetSuccessMessage: false,
        showResetFailureMessage: false
      };
    case PIN_OPEN_FORGOT_PIN_MODAL:
      return {
        ...state,
        isForgotPinModalOpen: true,
        isForgotPinSuccessMessageVisible: false,
        isForgotPinFailureMessageVisible: false
      };
    case PIN_CLOSE_FORGOT_PIN_MODAL:
      return {
        ...state,
        isForgotPinModalOpen: false
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/pin.js